import * as yup from 'yup'

export const SignUpSchema = yup.object().shape({
    firstname: yup.string().required('First name is required'),
    lastname: yup.string().required('Last name is required'),
    phonenumber: yup
        .string()
        .matches(/^\+?\d+$/, 'Please enter a valid phone number')
        .required('Phone number is required'),
    email: yup
        .string()
        .email('Please enter a valid email')
        .required('Email is required'),
    password: yup.string().required('Password is required'),
    confirmPassword: yup
        .string()
        .required('Confirm password is required')
        .when('password', (password, schema) => {
            if (!!password) {
                return schema.oneOf([password], 'Passwords do not match')
            }
        }),
})

export const BusinessSignUpSchema = yup
    .object()
    .shape({
        jobTitle: yup.string().required('Job title is required'),
        //Regex to match phone numbers with + in front
        phonenumber: yup
            .string()
            .matches(/^\+?\d+$/, 'Please enter a valid phone number')
            .required('Phone number is required'),
        domainName: yup
            .string()
            .matches(/^[a-zA-Z0-9_-]+$/, 'Please enter a valid domain name')
            .required('Domain name is required'),
    })
    .concat(SignUpSchema)

export const LoginSchema = yup.object().shape({
    email: yup
        .string()
        .email('Please enter a valid email')
        .required('Email is required'),
    password: yup.string().required('Password is required'),
})

export const ResetPasswordSchema = yup.object().shape({
    oldPassword: yup.string().required('Current Password is required'),
    newPassword: yup.string().required('New Password is required'),
    confirmNewPassword: yup
        .string()
        .required('Retype password is required')
        .when('newPassword', (newpassword, schema) => {
            if (!!newpassword) {
                return schema.oneOf([newpassword], 'Passwords do not match')
            }
        }),
})

export const ProfileSchema = yup.object().shape({
    firstname: yup.string().required('First name is required'),
    lastname: yup.string().required('Last name is required'),
    bio: yup.string().nullable(),
})

export const BusinessBasicsSchema = yup.object().shape({
    companyname: yup.string().required('Company name is required'),
    domainName: yup
        .string()
        .matches(/^[a-zA-Z0-9_-]+$/, 'Please enter a valid domain name')
        .required('Domain name is required'),
})

export const InviteUserSchema = yup.object().shape({
    slots: yup.array().of(
        yup.object().shape({
            name: yup.string().required('Name is required'),
            email: yup
                .string()
                .email('Please enter a valid email')
                .required('Email is required'),
        })
    ),
})

export const InviteFormSchema = yup.object().shape({
    email: yup.string().required('Email is required'),
    message: yup.string().required('Message is required'),
})
